<form [formGroup]="enderecosForm">
  <div class="forms">
    <div class="row content-container">
      <div class="row info-container white-box">
        <h2>Endereços do cliente</h2>

        <app-endereco-base
          [enderecoForm]="enderecosForm"
          tipoEndereco="residencial"
        ></app-endereco-base>

        <app-endereco-base
          [enderecoForm]="enderecosForm"
          tipoEndereco="comercial"
          *ngIf="hasEnderecoComercial"
        ></app-endereco-base>

        <form [formGroup]="correspondenciaForm">
          <div class="form-group">
            <span class="icon envelope"></span>

            <div class="inputs">
              <label for="enderecoCorrespondencia">Endereço para correspondência</label>

              <select
                class="form-control"
                required
                appShowErrorMessages
                requiredMessage="O campo Endereço para correspondência é obrigatório"
                name="enderecoCorrespondencia"
                formControlName="enderecoCorrespondencia"
              >
                <option value="" selected disabled>Selecione...</option>

                <option value="RESIDENCIAL">RESIDENCIAL</option>

                <option *ngIf="hasEnderecoComercial" value="COMERCIAL">COMERCIAL</option>
              </select>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</form>

<app-botao-navegacao
  (previous)="onClickPrevious()"
  (next)="onClickNext()"
  [previousShow]="true"
  [nextShow]="true"
  [nextEnabled]="enderecosForm.valid"
></app-botao-navegacao>

<app-loader-circles *ngIf="showLoader"></app-loader-circles>

